export const FETCH_PENDING_APPROVALLIST_REQUEST = "FETCH_PENDING_APPROVALLIST_REQUEST";
export const FETCH_PENDING_APPROVALLIST_SUCCESS = "FETCH_PENDING_APPROVALLIST_SUCCESS";
export const FETCH_PENDING_APPROVALLIST_FAILURE = "FETCH_PENDING_APPROVALLIST_FAILURE";
